<template>
  <div class="page">
    <div class="search-wrap">
      <van-search
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @input="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="list-wrap">
      <div
        class="list"
        v-for="(item,index) in list"
        :key="index"
        @click="changePer(item)"
      >
        {{item.title}}
        <span class="T3">({{item.authroName}})</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Search, Toast, Dialog } from 'vant'
import http from '@/api/http'

export default {
  name: 'Search',
  components: {
    'van-search': Search
  },
  data() {
    return {
      value: '',
      productId: this.$route.query.productId,
      type: this.$route.query.type,
      list: []
    }
  },
  created() {
    console.log('created')
    this.productSearch()
    const type = parseInt(this.type)
    switch (type) {
      case 1:
        document.title = '更换锦囊'
        break
      case 2:
        document.title = '更换课程'
        break
      case 3:
        document.title = '更换直播'
        break
      case 4:
        document.title = '更换点金'
        break
      default:
        document.title = '搜索'
    }
  },
  methods: {
    onSearch() {
      console.log('onSearch')
      console.log(this.value)
      this.productSearch()
    },
    onCancel() {
      console.log('onCancel')
      this.$router.go(-1)
    },
    async productSearch() {
      let { detail } = await http.post('/shop/Data/ProductSearch', {
        type: this.type,
        keyword: this.value
      })
      this.list = detail
      if (this.list.length === 0) {
        Toast('无此内容')
      }
    },
    async changePer(item) {
      Dialog.confirm({
        title: '更换权限',
        message: `确认更换权限为：${item.title}`
      })
        .then(async () => {
          // on confirm
          let { result, detail } = await http.post('/order/Order/RightSwitch', {
            oldProductId: this.productId,
            newProductId: item.productId
          })
          if (result.code === 0) {
            console.log(detail)
            Toast('权限更换成功,请一分钟后查看')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1500)
          } else {
            Toast(result.msg)
          }
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  height: 100px;
  line-height: 100px;
  margin: 0 30px;
  border-bottom: 1px solid #dddddd;
  font-size: 32px;
  .name {
    font-size: 28px;
  }
}
</style>